import * as types from '@/store/mutations'
import api from '@/services/posts'

const getters = {
   posts: (state) => state.posts,
    getPost: (state) => (id) => {
        let post = state.posts.find(post => parseInt(id) === parseInt(post.meta.id))
        return post || null
    },

    getMostRecentPosts: (state) => (num) => {
        let posts = state.posts

        //console.log("store-posts returning most recent: "+ num +" out of " + posts.length);
        return posts.slice(0,num).pop();
    }

}

const actions = {
    getAllPosts({ commit }) {

        return new Promise((resolve, reject)=>{
            let usingCache = false
            const existingCache = JSON.parse(window.localStorage.getItem('postCache'))
            const existingCacheLifetime = JSON.parse(
                window.localStorage.getItem('postCacheLifetime')
            )
            if (existingCache && existingCacheLifetime) {
                if (existingCache.length > 0 && existingCacheLifetime > Date.now()) {
                    commit(types.SET_POSTS, existingCache)
                    resolve(1)
                    usingCache = true
                }
            }

          /* usingCache = false */

            if (usingCache === false) {
                api.postList('200').then((res)=>{
                    const posts = []
                    res.map((prod)=>{
                        posts.push(prod)
                    })
                    commit(types.SET_POSTS, posts)
                    window.localStorage.setItem(
                        'postCache',
                        JSON.stringify(posts)
                    )
                    const addedTime =  new Date();
                    const newLifetime = addedTime.setHours(addedTime.getHours() + 4)
                    window.localStorage.setItem(
                        'postCacheLifetime',
                        JSON.stringify(newLifetime)
                    )
                    resolve(1)
                }).catch((ex)=>{
                    reject(ex)
                })
            }
        })
    },

}

const mutations = {
    [types.SET_POSTS](state, payload){
        state.posts = payload
    }
}

const state = {
    posts: [],
}

export default {
    state,
    getters,
    actions,
    mutations
}
